import { render, staticRenderFns } from "./BookNParkDevtoolsPanel.vue?vue&type=template&id=05d03661&scoped=true"
import script from "./BookNParkDevtoolsPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookNParkDevtoolsPanel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BookNParkDevtoolsPanel.vue?vue&type=style&index=0&id=05d03661&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.27_css-loader@6.7.4_webpack@5.103.0__ejs@3.1.1_b66b1f2fa9fe053e2de99336b754991c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d03661",
  null
  
)

export default component.exports